import { json } from "@sveltejs/kit";
import { g as getHealthStatus } from "../../../../chunks/health.js";
const GET = async () => {
  const health = await getHealthStatus();
  return json(health);
};
export {
  GET
};
